import React, { useState } from 'react';
import StartScreen from './components/StartScreen';
import UserInfo from './components/UserInfo';
import QuizPage from './components/QuizPage';
import Header from './components/Header'
import Footer from './components/Footer';
import './App.css';

function App() {
  const [step, setStep] = useState('start');
  const [userInfo, setUserInfo] = useState(null);

  const handleStart = () => {
    setStep('userinfo');
  };

  const handleUserInfoSubmit = (info) => {
    setUserInfo(info);
    setStep('quiz');
  };

  return (
    <div className="App">
      <Header />
      {step === 'start' && <StartScreen onStart={handleStart} />}
      {step === 'userinfo' && <UserInfo onSubmit={handleUserInfoSubmit} />}
      {step === 'quiz' && <QuizPage userInfo={userInfo} />}
      <Footer />
    </div>
  );
}

export default App;
